import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { salaDePrensaJson } from '../pages/sala-de-prensa/sala-de-prensa.json';
import { environment } from 'src/environments/environment';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalaDePrensaService {

  endpointApi = environment.apiCms;

  articulosSala: any;

  size: number = 10000;
  page: number = 0;

  constructor(private http: HttpClient) { }

  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getSalaDePrensaData() {
    this.articulosSala = this.http.get<any>(this.endpointApi + 'list?size=' + this.size)
      .pipe(
        map(resp => {
          return resp;
        }),
        catchError(this.handleError)
      )

    return this.articulosSala;
  }


  // getSalaDePrensaData() {
  //   return salaDePrensaJson;
  // }
}
